<wizard-labeled-field label="Video Conferencing" [size]="fieldSize">
    <wizard-tooltip>
        If you have enabled a video conferencing link for the associated meeting type it will automatically be added to
        your meeting invites, so your invitees know how to connect with you. A confirmation will appear here for
        reference.
        <a
            href="https://faq.calendarhero.com/hc/en-us/articles/4430392661147-How-do-I-connect-my-video-conference-software-"
            target="_blank"
        >
            Learn More</a
        >
    </wizard-tooltip>
    <div>
        <div *ngIf="videoProvider" class="ui circular icon label margin-right-10">
            <i class="video bluegrey icon"></i>
        </div>
        <!-- TODO: Sanitize this properly with a pipe -->
        <span [innerHTML]="videoProviderDisplay" class="video-provider-display-text"></span>
    </div>
</wizard-labeled-field>
